import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatDialog as MatDialog } from "@angular/material/dialog";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import _ from "lodash";
import { AlertService } from "src/app/services/alert.service";
import { CFAPIService } from "src/app/services/api.service";
import { AuthService } from "src/app/services/auth.service";
import { CustomerService } from "src/app/services/customer.service";
import { LivecoAPIService } from "src/app/services/liveco-api.service";
import { LoaderService } from "src/app/services/loader.service";
import { ProjectService } from "src/app/services/project.service";
import { ViewComponent } from "src/app/shared/pages/view/view.component";
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: "app-filters",
    templateUrl: "./filters.component.html",
    styleUrls: ["./filters.component.scss"],
})
export class FiltersComponent<T> extends ViewComponent implements OnInit {

    protected _filters: T;

    protected _resettedFilters: T;

    get filters() {
        return this._filters;
    }

    @Input() set filters(value: T) {
        this._filters = value;
        this.filtersChange.emit(this._filters);
    }

    @Output() filtersChange = new EventEmitter<T>();

    get page() {
        return this.s_projects.page;
    }

    get customerName(): string | undefined {
        return this.currentUser?.customer?.name;
    };

    get marqueLabel(): string | undefined {
        if (!this.currentUser?.marques || this.currentUser?.marques.length < 1) {
            return undefined;
        }

        return this.currentUser.marques.join(", ");

    };

    @Output() onFilter = new EventEmitter<T>();

    constructor(
        protected route: ActivatedRoute,
        protected router: Router,
        protected s_alert: AlertService,
        protected s_loader: LoaderService,
        protected dialog: MatDialog,
        protected s_auth: AuthService,
        protected titleService: Title,
        protected liveco: LivecoAPIService,
        protected s_projects: ProjectService,
        protected s_customer: CustomerService,
    ) {
        super(route, router, s_alert, s_loader, s_auth);
    }

    async ngOnInit(): Promise<void> {
    }

    submit() {
        this.onFilter.emit(this.filters);
    }

    resetForm() {
        this.page.$skip = 0;
        this.filters = { ...this._resettedFilters };
        this.submit();
    }
}
